// NAVBAR
export const NBUTTON1 = "About Us";
export const NBUTTON2 = "Contact Us";
export const NBUTTON3 = "Internship Programs";
export const NBUTTON4 = "My Internships";
export const NBUTTON5 = "My Profile";
export const NBUTTON6 = "Reference Tutorials";

// AUTH BUTTON
export const LOGINBUTTON = "Sign In";
export const SIGNINBUTTON = "Sign Up";
export const LOGOUTBUTTON = "Log Out";

// INTERNSHIP TYPES
export const INTERNTYPE1 = "Design Internships";
export const INTERNTYPE2 = "Devlopment Internships";
export const INTERNTYPE3 = "Marketing Internships";
